import React from 'react';
import PropTypes, {InferProps} from 'prop-types';
import UserContext from 'context/user/UserContext';
import type {EfeUser} from 'commons/types/Types';

const defaultContextValue = {
    username: '',
    idSalesforce: '',
    fullName: '',
    email: '',
    loggedIn: false,
    tokenType: '',
    token: '',
    expires: 0,
    refreshToken: '',
    pendingActions: ['Login'],
    expirationDate: null,
    isMigrated: false,
    contractService: false,
    logout: false,
    isAdmin: false,
};

function EfeUserProvider(props: InferProps<typeof EfeUserProvider.propTypes>) {
    const {children} = props;
    const [user, setUser] = React.useState<EfeUser>(defaultContextValue);
    const [beneficiaryToken, setBeneficiaryToken] = React.useState<boolean>(false);

    function isAdmin(): boolean {
        return user.isAdmin;
    }

    const updateUser = (data: EfeUser) => {
        setUser(data);
    };

    const resetUserProvider = () => {
        setUser(defaultContextValue);
        setBeneficiaryToken(false);
    };

    return (
        <UserContext.Provider
            value={{
                user,
                updateUser,
                resetUserProvider,
                isAdmin,
                beneficiaryToken,
                setBeneficiaryToken,
            }}>
            {children}
        </UserContext.Provider>
    );
}

EfeUserProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default EfeUserProvider;
